import React from 'react';
import { ArrowRight, CalendarDays, MessageSquareText, Headphones, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';
import { heroImage } from '../mock';

const QuickAction = ({ Icon, label, to }) => (
  to.startsWith('tel:') ? (
    <a href={to} className="group flex items-center justify-between gap-3 border border-neutral-200 rounded-full px-5 py-3 hover:border-[#CA0028] hover:bg-[#CA0028] hover:text-white transition-all duration-300">
      <span className="flex items-center gap-3 text-[14px] font-medium">
        <span className="w-7 h-7 rounded-full bg-neutral-100 group-hover:bg-white/10 grid place-items-center transition-colors">
          <Icon size={14} />
        </span>
        {label}
      </span>
      <ArrowRight size={16} className="opacity-40 group-hover:opacity-100 group-hover:translate-x-1 transition-all" />
    </a>
  ) : (
    <Link to={to} className="group flex items-center justify-between gap-3 border border-neutral-200 rounded-full px-5 py-3 hover:border-[#CA0028] hover:bg-[#CA0028] hover:text-white transition-all duration-300">
    <span className="flex items-center gap-3 text-[14px] font-medium">
      <span className="w-7 h-7 rounded-full bg-neutral-100 group-hover:bg-white/10 grid place-items-center transition-colors">
        <Icon size={14} />
      </span>
      {label}
    </span>
    <ArrowRight size={16} className="opacity-40 group-hover:opacity-100 group-hover:translate-x-1 transition-all" />
  </Link>
  )
);

const Hero = () => {
  return (
    <section className="relative">
      <div className="max-w-[1240px] mx-auto px-6 pt-6">
        <div className="relative rounded-[28px] overflow-hidden bg-neutral-100 min-h-[560px] lg:min-h-[640px] fade-up">
          <img
            src={heroImage}
            alt="Physiotherapist treating patient"
            className="absolute inset-0 w-full h-full object-cover object-right"
            loading="eager"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-white/95 via-white/70 to-transparent" />

          <div className="relative z-10 max-w-[600px] px-8 lg:px-14 py-16 lg:py-20">
            <span className="inline-flex items-center rounded-full border border-neutral-300 bg-white/70 backdrop-blur px-4 py-1.5 text-[12px] font-medium text-neutral-800">
              A sanctuary of health and wellness
            </span>

            <h1 className="mt-6 text-[52px] lg:text-[76px] leading-[0.95] font-bold tracking-[-0.045em] text-neutral-900">
              Move Better.<br />
              Live <span className="font-serif-italic font-normal">Stronger.</span>
            </h1>

            <p className="mt-6 max-w-md text-[15px] leading-relaxed text-neutral-600">
              Evidence-informed physiotherapy for pain, injury and performance.
              Our team listens before it treats and builds a plan around your
              body, your goals, and your life.
            </p>

            <Link to="/team" className="mt-8 inline-flex items-center gap-2 bg-[#CA0028] hover:bg-[#A80021] text-white text-[14px] font-medium pl-6 pr-2 py-2 rounded-full transition-colors">
              Meet Our Team
              <span className="w-8 h-8 grid place-items-center rounded-full bg-white/15">
                <ArrowRight size={14} />
              </span>
            </Link>
          </div>
        </div>

        {/* Quick actions */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 mt-6">
          <QuickAction Icon={CalendarDays} label="Call to Book" to="tel:+15192522752" />
          <QuickAction Icon={MessageSquareText} label="Free Injury Screen" to="/contact" />
          <QuickAction Icon={Headphones} label="+1-519-252-2752" to="tel:+15192522752" />
          <QuickAction Icon={MapPin} label="Find A Clinic" to="/locations" />
        </div>
      </div>
    </section>
  );
};

export default Hero;
